import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
  provideAppCheck,
} from '@angular/fire/app-check';
import { getApp } from '@angular/fire/app';
import { environment } from '../../../environments/environment';

/**
 * Sets up Firebase App Check with reCAPTCHA Enterprise.
 *
 * - Localhost: enables debug token (must be registered manually in Firebase Console)
 * - Deployed apps (dev/stg/prod): uses reCAPTCHA Enterprise with the site key
 *   registered for each environment's domain.
 */
export function provideOurMemoryAppCheck() {
  return provideAppCheck(() => {
    configureDebugTokenIfLocalhost();
    return initializeAppCheck(getApp(), {
      provider: new ReCaptchaEnterpriseProvider(environment.recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  });
}

function configureDebugTokenIfLocalhost(): void {
  const globalScope = self as unknown as Record<string, unknown>;
  if (isLocalhost()) {
    globalScope['FIREBASE_APPCHECK_DEBUG_TOKEN'] = true;
    return;
  }
  // AngularFire auto-enables debug token when Angular isDevMode() is true.
  // For deployed envs (dev.ourmemory.app, stg, prod) we must explicitly
  // delete it so reCAPTCHA Enterprise is used instead.
  delete globalScope['FIREBASE_APPCHECK_DEBUG_TOKEN'];
}

function isLocalhost(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}
